import React, { useState } from "react";
import { Link } from "react-router-dom";
import useSubmitting from "../../hooks/useSubmitting";
import baseUrl from "../../api/baseUrl";
import { setEncryptedTokens } from "../../utils/crypto/cryptoUtils";
import LoginShell from "./LoginShell";
import { EyeOff, EyeOpen } from "./PasswordToggleIcons";
import { inputClass, linkClass, submitClass } from "./loginStyles";

function AdminLogIn() {
  const [formdata, setformdata] = useState({
    email: "",
    password: "",
    error: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, wrap] = useSubmitting();

  const handlechange = (e: any) => {
    setformdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const onSubmit = (e: any) => {
    e.preventDefault();
    localStorage.clear();

    baseUrl
      .post("admin/superemployee/user-login", formdata)
      .then((response) => {
        const secretData = [
          { key: "user", value: response.data.data.user },
          { key: "token", value: response.data.data.token },
          {
            key: "routeAccess",
            value: JSON.stringify(response.data.data.routeAccess),
          },
          {
            key: "permissionDenied",
            value: JSON.stringify(response.data.data.permissionDenied),
          },
        ];
        setEncryptedTokens(secretData);
        window.location.reload();
        window.location.href = "/admin/dashboard";
      })
      .catch((error) => {
        setformdata({ ...formdata, error: true });
        console.error(error);
      });
  };

  return (
    <LoginShell
      variant="admin"
      title="Admin sign in"
      subtitle="Access system settings and staff permissions."
    >
      <form onSubmit={wrap(onSubmit)} className="flex w-full flex-col gap-4">
        <div className="flex w-full flex-col gap-[7px]">
          <label htmlFor="admin-email" className="login-label">
            Email
          </label>
          <input
            id="admin-email"
            name="email"
            type="email"
            placeholder="name@company.com"
            className={inputClass("admin")}
            onChange={handlechange}
            value={formdata.email}
            autoComplete="username"
            required
          />
        </div>
        <div className="flex w-full flex-col gap-[7px]">
          <label htmlFor="admin-password" className="login-label">
            Password
          </label>
          <div className="relative w-full">
            <input
              id="admin-password"
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Enter password"
              className={`${inputClass("admin")} pr-11`}
              onChange={handlechange}
              value={formdata.password}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="absolute right-2.5 top-1/2 m-0 inline-flex -translate-y-1/2 items-center justify-center border-0 bg-transparent p-1 text-[#7a8781] hover:bg-transparent hover:text-login-ink"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              tabIndex={-1}
            >
              {showPassword ? <EyeOff /> : <EyeOpen />}
            </button>
          </div>
        </div>
        <Link
          to="/admin-forgot-password"
          className={`${linkClass("admin")} -mt-1 self-end`}
        >
          Forgot password?
        </Link>
        <button
          type="submit"
          disabled={submitting}
          className={submitClass("admin")}
        >
          {submitting ? "Signing in..." : "Sign in"}
        </button>
        {formdata.error ? (
          <span className="login-error">Invalid credentials</span>
        ) : null}
      </form>
    </LoginShell>
  );
}

export default AdminLogIn;
